@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  display: flex;
}

.previewContainer {
  height: 100vh;
  width: 392px;
  min-width: 392px;
  background-color: var(--dark-3);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.logout {
  position: fixed;
  top: 13px;
  right: 15px;
  z-index: 2001;

  &.withSiderImage {
    right: calc(15px + (100vh * 630 / 1546));
  }
}
